<template>
  <div>
    <AppAccordion
      :is-open="openAccordion === om_mobilenId"
      :base-html-id="om_mobilenId"
      :only-mobile="false"
      border-color="secondary"
      show-border-top
      @on-toggle="closeAllOther($event.isOpen, $event.id)"
    >
      <template #header>
        <h2 v-if="store.product?.Category === 'Mobiler'" class="heading-xxs">
          Om mobilen
        </h2>
        <h2 v-else class="heading-xxs">Om {{ store.product?.ProductName }}</h2>
      </template>
      <MarkupGenerator
        v-if="descriptionMarkupData"
        :page-data="descriptionMarkupData"
        :is-page="false"
      />
    </AppAccordion>
    <template
      v-if="
        store.product?.Specifications &&
        store.product?.Specifications.length > 0
      "
    >
      <AppAccordion
        :is-open="openAccordion === specifikationerId"
        :base-html-id="specifikationerId"
        :only-mobile="false"
        border-color="secondary"
        @on-toggle="closeAllOther($event.isOpen, $event.id)"
      >
        <template #header>
          <h2 class="heading-xxs">Specifikationer</h2>
        </template>
        <ul class="pb-32">
          <li
            v-for="spec in store.product?.Specifications"
            :key="spec.Name + spec.Value"
            class="mb-16"
          >
            <p class="heading-xxs">{{ spec.Name }}</p>
            <p>{{ spec.Value }}</p>
          </li>
        </ul>
      </AppAccordion>
    </template>
    <AppAccordion
      v-if="store.product?.Category === 'Mobiler'"
      :is-open="openAccordion === mobilabonnemangId"
      :base-html-id="mobilabonnemangId"
      :only-mobile="false"
      border-color="secondary"
      @on-toggle="closeAllOther($event.isOpen, $event.id)"
    >
      <template #header>
        <h2 class="heading-xxs">Mobilabonnemang</h2>
      </template>
      <p>
        Alla mobilabonnemang hos oss har alltid fria samtal, sms & mms inom
        Sverige och fri roaming i EU/EES. Vi har olika surfmängder och du väljer
        hur mycket surf du behöver. Den surf du inte använder får du behålla och
        du kan som max spara lika mycket surf som du har i ditt mobilabonnemang.
        T.ex har du 20GB surf kan du spara 20GB surf. Skulle du behöva extra
        surf någon månad kan du enkelt köpa till mer.
      </p>
      <br />
      <p>
        Köper du mobil + abonnemang får ditt abonnemang en bindningstid på 24
        månader, oavsett om du väljer 12, 24 eller 36 månaders delbetalning av
        mobilen.
      </p>
      <br />
      <p>
        De kostnader som kan tillkomma på din faktura är samtal, sms eller mms
        till/från utlandet, som inte ingår i EU/EES, betalsamtal, sms-köp eller
        andra liknande tjänster.
      </p>
      <br />
      <p class="pb-32">
        Som mobilkund hos oss har du även tillgång till support dygnet runt,
        årets alla dagar!
      </p>
    </AppAccordion>
    <AppAccordion
      v-if="store.product?.Category === 'Mobiler'"
      :is-open="openAccordion === tackningId"
      :base-html-id="tackningId"
      label="Täckning"
      :only-mobile="false"
      border-color="secondary"
      @on-toggle="closeAllOther($event.isOpen, $event.id)"
    >
      <template #header>
        <h2 class="heading-xxs">Täckning</h2>
      </template>
      <p class="pb-32">
        Som Halebopkund surfar du i Telias nät. Idag täcker vi 91% av Sveriges
        yta och når 99.9% av befolkningen med både 4G och 5G. Endast 5G nätet
        når idag 81%. Det byggs fortfarande ut och ambitionen är att under 2025
        nå hela 99%.
      </p>
    </AppAccordion>
  </div>
</template>

<script lang="ts" setup>
import type { MarkupData } from '~/repository/modules/category.module';
const id = useId();
const tackningId = 'tackning-' + id;
const mobilabonnemangId = 'mobilabonnemang-' + id;
const specifikationerId = 'specifikationer-' + id;
const om_mobilenId = 'om_mobilen-' + id;
const store = useMyProductPageStore();

const openAccordion = ref<string>('');

const closeAllOther = async (isOpen: boolean, id: string) => {
  if (isOpen) {
    openAccordion.value = id;
  }
};

const descriptionMarkupData = computed(() => {
  if (!store.product?.Description) {
    return undefined;
  }

  const markupData: MarkupData = {
    PageContent: store.product.Description,
  };

  return markupData;
});
</script>

<style lang="scss">
.pdp__info-accordions__product-description {
  p {
    margin-bottom: 1.6rem;
  }
}
</style>
